import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useAuth } from '../../core/authContext';
import { HEIGHT_BELOW_BARS } from '../../core/bannerOffset';

export function OldLanding() {
  const { user, signOut } = useAuth();
  const greeting = user?.first_name ? `, ${user.first_name}` : '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: HEIGHT_BELOW_BARS, p: 2 }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 520, textAlign: 'center' }}>
        <Stack spacing={3}>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            Coming soon{greeting}.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Flashlight Learning is on its way.
          </Typography>
          <Box>
            <Button variant="outlined" onClick={signOut}>
              Sign out
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}
